import React, {Component} from 'react';
import {Container} from './industry_container';
import {Boxdataset} from './ui_components/boxdataset';
import {UI_Table} from './ui_components/ui-table'

export function Commercial_estate(props){
  var commercial_data = props.commercial_data

  var temp_delete = []  
  return (
    
    <div className='sidebar-realestate-total'>
      <div id='pdf-export-container-commercial' >
        {props.exportInd && <h2 className='mb-20 mt-100 font-weight600 data-component'>Commercial Real Estate</h2>}

      <div className="boxdata-header data-component">Commercial Real Estate Cost</div>
        {/* <Boxdataset classnameval="box-container" margin={167}  top_text='Housing Cost' mid_text="Avg. Cost of house" total_diff={(housing_buy.nums[10] - housing_buy.nums[0]) / housing_buy.nums[0]} total_current={"$"+housing_buy.nums[10]} total_past={"$"+housing_buy.nums[0]} type={type_industry} description="Average cost of house in the target region. Average based on research data on the Zipcode level. Previous Period: 2012" filters={{}}/>: null} */}
        <div className='display-flex gap-20 data-component'>
          <Boxdataset exportInd={props.exportInd} classnameval="box-container pb-40" margin={167}  top_text='Average Leasing' mid_text="Monthly Sqft. Cost" type={!props.commercial_data.loading} total_current={props.commercial_data.averageRentSqFtMonthly} description="Average lease cost of locations within the region." filters={{}}/>
          <Boxdataset exportInd={props.exportInd} classnameval="box-container  pb-40" margin={167}  top_text='Average Buying' mid_text="Sqft. Cost" type={!props.commercial_data.loading} total_current={props.commercial_data.averageBuySqFt} description="Average lease cost of locations within the region." filters={{}}/>
        </div>
      </div>
      <div id='pdf-export-container-commercial-second' className='pt-20'>
      {(!props.commercial_data.loading) && <div className='margin-top-10 data-component'>
        {(commercial_data.location_total_agg.length > 0) && <UI_Table rows={commercial_data.location_total_agg} titles={[{title: 'Competitor Name', key:'Name_final'}, {title: 'Est. Total Locations', key: 'loc_count'}, {title: 'Locations On Map', key: 'count'}]}/>}
      </div>}
      {(!props.commercial_data.loading) && <div className='mt-20 data-component'>
        {(commercial_data.shops_near.length > 0) && <UI_Table rows={commercial_data.shops_near} titles={[{title: 'Shopping Center', key:'Name_final'}, {title: 'Est. Number Stores', key: 'loc_overlap_count'}, {title: 'Est. Monthly Rent Sqft.', key: 'average_rent_sqft'}]}/>}
      </div>}
      </div>
    </div>
        )
              } 